<template>
  <div class="container w100 relative-container">
    <div class="padded">
      <wrap-container class="w50-fixed">
        <form-validator>
          <step-header v-if="!embeded" />
          <wrap-container>
            <employment-situation
              v-model="model.situacionLaboral"
              quantumObfuscate
            />
            <job-occupation
              v-model="model.ocupacion"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
            <work-activity
              v-model="model.actividad"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
            <cuil-type
              v-show="showSelectTipoCuild"
              v-model="model.tipoCuil"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
            <cuil-input
              v-model="model.cuil"
              :type="model.tipoCuil"
              :required="true"
              maxlength="11"
              quantumObfuscate
            />
          </wrap-container>
          <step-navigator
            v-model="model"
            store-action="DO_DATOS_LABORALES"
            analyticsName="continuar"
            :routerPush="true"
          />
        </form-validator>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepHeader from "@/components/core/StepHeader";
import EmploymentSituation from "@/components/core/composite/combos/EmploymentSituation";
import JobOccupation from "@/components/core/composite/combos/JobOccupation";
import WorkActivity from "@/components/core/composite/combos/WorkActivity";
import StepNavigator from "@/components/core/StepNavigator";
import CuilInput from "@/components/core/composite/CuilInput";
import CuilType from "@/components/core/composite/combos/CuilType";
import { cuilGen } from "@/utils";

export default {
  name: "DatosLaborales",
  components: {
    WrapContainer,
    FormValidator,
    StepHeader,
    EmploymentSituation,
    JobOccupation,
    WorkActivity,
    CuilInput,
    StepNavigator,
    CuilType
  },
  props: {
    embeded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.$store.getters.getDatosLaborales(),
      situacionLaboral: this.$store.getters.getDatosLaborales().situacionLaboral
    };
  },
  mounted() {
    // Generar CUIL
    if (this.model.cuil === "") {
      this.model.cuil = cuilGen(
        this.$store.getters.getConsulta().numeroDoc ||
          this.$store.getters.getConsulta().nroDoc,
        this.$store.getters.getConsulta().sexo
      );
    }
  },
  computed: {
    showSelectTipoCuild() {
      return this.model.situacionLaboral === "002";
    }
  }
};
</script>

<style scoped>
#titulo {
  margin-bottom: 16px;
}

#subtitulo {
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 40px;
}

.container {
  margin-top: 16px !important;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
</style>
